module.exports = __webpack_public_path__ + "static/media/flower-bouquet.34492496.svg";